module.exports = __webpack_public_path__ + "static/img/14000583.663b99bf.png";